import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const useStyles = makeStyles(() => ({
  control: {
    textAlign: "right",
    paddingTop: "0.9375rem",
    marginBottom: "-2px",
    marginRight: "-6px",
  },
}));

function PageControl(props) {
  const classes = useStyles();
  return <div className={classes.control}>{props.children}</div>;
}

export default PageControl;
